module.exports = __webpack_public_path__ + "img/GAME_DICTATION2.252ec6fd.jpg";